import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { UserOutlined, MailOutlined } from '@ant-design/icons'
import { Menu, Dropdown, Avatar, notification } from 'antd'
import store from 'store'
import { history } from 'index'
import Cookies from 'js-cookie'
import { getLoggedInUserInfo } from 'utils'
import styles from './style.module.scss'
import { useMsal } from '../../Auth/Login/msalContext'

const mapStateToProps = ({ user }) => ({ user })

const ProfileMenu = ({ user }) => {
  const msalInstance = useMsal()
  const userInfo = getLoggedInUserInfo()
  const { email, userId } = userInfo
  const [profileImage, setProfileImage] = useState(null)
  const [imageError, setImageError] = useState(false)

  const baseURL =
    process.env.NODE_ENV === 'development'
      ? process.env.REACT_APP_DEV_BASE_URL
      : `${process.env.REACT_APP_PROD_BASE_URL}/`
  const imagePathUrl = baseURL.replace('/api/v1', '')

  useEffect(() => {
    if (userId) {
      const imageUrl = `${imagePathUrl}api/v1/userInfo/profile/${userId}?v=${new Date().getTime()}`

      // Test if the image exists before setting it
      const img = new Image()
      img.onload = () => {
        setProfileImage(imageUrl)
        setImageError(false)
      }
      img.onerror = () => {
        setProfileImage(null)
        setImageError(true)
      }
      img.src = imageUrl
    }
  }, [userId, user?.detailedInfo?.userProfileImg?.mediaLink])

  const logout = async (e) => {
    e.preventDefault()

    try {
      const accounts = msalInstance.getAllAccounts()
      console.log('All accounts:', accounts)

      const homeAccountId = accounts[0]?.homeAccountId
      console.log('homeAccountId', homeAccountId)

      const accountToLogout = msalInstance.getAccountByHomeId(homeAccountId)
      console.log('accountToLogout', accountToLogout)

      // Clear app session
      Cookies.remove('accessToken')
      Cookies.remove('permissions')
      store.set('app.menu.openedKeys', [])
      store.set('app.menu.selectedKeys', [])

      if (accountToLogout) {
        console.log('Logging out account:', accountToLogout)
        await msalInstance.logoutPopup({
          account: accountToLogout,
        })
      }

      notification.success({
        message: 'Logged Out',
        description: 'You have been successfully logged out.',
      })

      history.push('/auth/login')
    } catch (error) {
      console.error('Logout error:', error)
      notification.error({
        message: 'Logout Failed',
        description: 'An error occurred during logout. Please try again.',
      })
    }
  }

  const menu = (
    <Menu selectable={false}>
      <Menu.Item>
        <div>
          <MailOutlined /> {email || '—'}
        </div>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item>
        <a href="/profile">
          <i className="fe fe-user mr-2" />
          <FormattedMessage id="topBar.profileMenu.editProfile" />
        </a>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item>
        <a href="#" onClick={logout}>
          <i className="fe fe-log-out mr-2" />
          <FormattedMessage id="topBar.profileMenu.logout" />
        </a>
      </Menu.Item>
    </Menu>
  )

  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <div className={styles.dropdown} id="profile">
        <Avatar
          className={styles.avatar}
          shape="square"
          size="large"
          src={profileImage && !imageError ? profileImage : undefined}
          icon={<UserOutlined />}
          onError={() => {
            setImageError(true)
            setProfileImage(null)
            return false
          }}
        />
      </div>
    </Dropdown>
  )
}

export default connect(mapStateToProps)(ProfileMenu)
